import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';
import { ClientLandingPage } from '../types';

export const getClientLandingPage = async (): Promise<ClientLandingPage[]> => {
  const fetchResponse = await apiFetch(`${env.VITE_API_URL}/pb/s/api/sqo-portal/client-landing`, {
    method: 'GET',
  });

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as ClientLandingPage[];
  return response;
};
